/**
 * 通用混合
 * */
import Api from '@/api/platform/code'
import menuApi from '@/api/system/menu'
import store from '@/store'
import setting from '@/setting'
import util from '@/libs/util';
export default {
    methods: {
        getSn () {
            return new Promise(function (resolve, reject) {
                let data = {
                    nameCn: 'platform',
                    nameDe: '',
                    nameEn: ''
                }
                Api.generateSn(data).then(res => {
                    resolve(res)
                })
            })
        },
        getPermission () {
            let module = store.getters['admin/menu/currentModule'];
            let data = { sn: module.sn }
            return new Promise(function (resolve, reject) {
                menuApi.getAuthByMenu(data).then(res => {
                    let auth = {};
                    let nameEnArr = res.map(item => item.nameEn);
                    let isShowArr = res.map(item => item.isShow);
                    for (let i = 0; i < nameEnArr.length; i++) {
                        auth[nameEnArr[i]] = isShowArr[i];
                    }
                    resolve(auth)
                })
            })
        },
        getHeaders () {
            let headers = {};
            const token = util.cookies.get('token');
            const moduleId = util.cookies.get('moduleId');
            headers['access-token'] = token;
            headers['prod'] = setting.prod;
            headers['model'] = moduleId;
            return headers;
        }
    }
};



// WEBPACK FOOTER //
// ./src/mixins/module.js